import React, {useCallback, useEffect, useMemo, useState} from 'react';
import _ from 'lodash';
import {useTranslation} from 'react-i18next';

import MultiItem from './MultiItem';
import {MultiListContainer} from '../../styled/MultiStyle';
import MultiListType from "./MultiList/MultiListType";
import styled from "styled-components";

;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;


const ExtraSpan = styled.span`
  margin-left: 4px;
  color: ${props => props.theme.color.dark_200};
`;

const MultiList = ({multiList, multiLPChart, isLoading}) => {
    const {t} = useTranslation();
    // const [newItem, setNewItem] = useState({});
    // const [list, setList] = useState([]);
    // const [duoList, setDuoList] = useState([]);
    const [openId, setOpenId] = useState(0);
    const [renderType, setRenderType] = useState(0);
    const [typeButtonPressed, onChangeTypeButtonPressed] = useState(false);
    // const [multiList, setmultiList] = useState(_.uniqBy(multiList, (e) => e.summoner_info.summoner_id));
    const [sortedList, setSortedList] = useState([]);
    const DUO_START = 1;
    const DUO_LIMIT = 3;


    // const initialSort = [
    //     {
    //         value: 'ai_score',
    //         sortType: false,
    //     },
    // ]


    useEffect(() => {
        if (Array.isArray(multiList)) {
            const array = _.uniqBy(multiList, (e) => e.summoner.summoner_basic_info_dict.summoner_id);
            // setmultiList(array);
            const sortedMultilist = array.sort((a, b) => Number(b.summoner_info_dict.ai_score_avg) - Number(a.summoner_info_dict.ai_score_avg));
            setSortedList(sortedMultilist);
        }
    }, [multiList])

    const handleLayer = (id) => {
        const currentId = openId;
        if (currentId === id) {
            setOpenId(0);
        } else {
            setOpenId(id);
        }
    };

    //?????? 왜 있어야됨?
    // const getProcessData = useCallback(
    //     (arr) => {
    //         let newArr = [];
    //         arr.forEach((item, index) => {
    //             if (index !== 0) {
    //                 newArr.push(item);
    //             }
    //         });
    //
    //         let total = 0;
    //         let tmp = [];
    //         newArr.forEach((item, index) => {
    //             total += item.ai_score_total;
    //             let aa = 0;
    //             let bb = '';
    //             item?.summoner_match_list?.forEach((itm, idx) => {
    //                 aa = itm.matchId;
    //                 bb = itm.side;
    //                 newArr?.forEach((ii, xx) => {
    //                     if (index !== xx) {
    //                         ii?.summoner_match_list.forEach((i, x) => {
    //                             if (aa === i.matchId && bb === i.side) {
    //                                 tmp.push(ii.summoner_info.riot_id_name);
    //                             }
    //                         });
    //                     }
    //                 });
    //             });
    //         });
    //
    //         let set = new Set(tmp);
    //         setDuoList([...set]);
    //
    //         // getAvg((total / newArr.length).toFixed(1));
    //     },
    //     []
    // );

    // useEffect(() => {
    //     setList((list) => {
    //         return [...list, newItem];
    //     });
    // }, [newItem]);


    // //?????????????????
    // useEffect(() => {
    //     getProcessData(list);
    // }, [getProcessData, list]);


    const onClickTypeButton = (index) => {
        setRenderType(index);
        onChangeTypeButtonPressed(true);
    }


    const getDuoList = useCallback((multiList) => {
        return multiList.reduce((sum, cur) => {
            const curRank = cur.summoner.season_tier_info_dict.ranked_solo_5x5.tier;
            if (curRank !== 'CHALLENGER' && curRank !== 'GRANDMASTER' && curRank !== 'MASTER') {
                const currentId = cur.summoner?.summoner_basic_info_dict.summoner_id;
                const currentMatchList = cur?.summoner_info_dict?.last_match_list;
                const filterNotMy = multiList.filter((multiItem) => currentId !== multiItem.summoner.summoner_basic_info_dict.summoner_id);
                const calcu = filterNotMy.map((notMe) => {
                    const test = notMe.summoner_info_dict.last_match_list.filter((list) => currentMatchList.some((some) => some.is_win === list.is_win && some.match_id === list.match_id));
                    return {
                        is_duo: test.length > 0,
                        match_ids: test.map((data) => data.match_id),
                    };
                });


                sum.push({
                    summoner_id: currentId,
                    match_ids: _.uniq(calcu.reduce((sum, data) => [...sum, ...data.match_ids], [])),
                });

            }
            return sum;
        }, []);
    }, []);

    const getCombined = (arr, num) => {
        const results = [];
        if (num === 1) return arr.map(v => [v]);
        arr.forEach((fixed, index, origin) => {
            const rest = origin.slice(index + 1);
            const combinations = getCombined(rest, num - 1);
            const attached = combinations.map(v => [fixed, ...v]);
            results.push(...attached);
        });

        return results;
    }


    const getCombinations = useCallback((list) => {
        if (Array.isArray(list) && list.length > 0) {
            if (list.length === 1) return [];
            const result = [];
            new Array(list.length).fill("").forEach((data, index) => {
                if (index === 0) {
                    result.push(list);
                } else {
                    const answer = getCombined(list, list.length - index);
                    const filteredAnswer = answer.filter((data) => data.length > DUO_START);

                    result.push(...filteredAnswer);
                }
            })

            return result;
        }
        return [];
    }, [])


    const reduceMap = useMemo(() => {

        //경우의 수가 너무많이 존재함
        //많은 경우의 수를 전부다 코딩으로 작성하는게 불필요할정도로 길어서
        //전체 경우의수를 구한다음 거기에 대입하는 방식으로 되어있음. 5명이면 60000만개 정도의 경우의 수가 나옴.

        const colorPallet = ['#B1FFC8', '#C2EEFF', '#DED2FE', '#FFF3C2'];
        const textColorPallet = ['#1E714A', '#3D6384', '#61528A', '#775648'];
        const borderPallet = ['#7FD5AE', '#91BFE6', '#A895DE', '#E3A489'];
        let colorPattern = 0;
        if (Array.isArray(multiList) && multiList.length > 1) {
            const list = getDuoList(multiList);
            const matches = _.uniq(list.reduce((sum, cur) => [...sum, ...cur.match_ids], []));
            const combinationList = getCombinations(matches, 1);
            const result = list.reduce((sum, cur) => {
                const sortedList = cur.match_ids.sort();
                if (sortedList.length > 0) {
                    new Array(sortedList.length - 1).fill("").forEach((data, index) => {
                        const combined = getCombined(sortedList, sortedList.length - index);
                        combined.map((combinedData) => {
                            const answer = combinationList.find((data) =>
                                data.length === combinedData.length &&
                                combinedData.every((every, index) => {
                                    return data.includes(every);
                                }));
                            if (answer) {
                                sum[answer.toString()] = {
                                    matches: answer,
                                    count: sum[answer.toString()]?.count ? sum[answer.toString()]?.count + 1 : 1,
                                    summoner_id: sum[answer.toString()]?.summoner_id ? [...sum[answer.toString()]?.summoner_id, cur.summoner_id] : [cur.summoner_id],
                                }
                            }
                        })
                    })
                }

                return sum;
            }, []);

            const deleteSame = Object.values(result).reduce((sum, cur) => {
                const sortSummonerId = cur.summoner_id.sort();
                const filtered = Object.values(sum).filter((data) => data.summoner_id.length === cur.summoner_id.length && data.summoner_id.sort().every((data, index) => data === sortSummonerId[index]));
                if (filtered.length > 0) {
                    return sum;
                } else {
                    sum[cur.matches.toString()] = ({...cur});
                }
                return sum;
            }, {});

            let lastObj = {};
            for (const obj in deleteSame) {
                if (deleteSame[obj]?.count > DUO_START) {
                    if (deleteSame[obj]?.count > DUO_LIMIT) {
                        lastObj[obj] = {
                            ...deleteSame[obj],
                            summoner_id: deleteSame[obj].slice(0, DUO_LIMIT),
                        }
                    } else {
                        lastObj[obj] = {
                            ...deleteSame[obj],
                        }
                    }
                    lastObj[obj] = {
                        ...lastObj[obj],
                        background: colorPallet[colorPattern],
                        textColor: textColorPallet[colorPattern],
                        borderColor: borderPallet[colorPattern],
                    }
                    if (colorPattern < colorPallet.length - 1) {
                        colorPattern++
                    }

                }
            }
            return Object.values(lastObj);

        }
        return [];
    }, [multiList])


    const renderMap = useCallback(() => {
        return multiList.length > 0 && multiList.map((multiItem, index) => {
            const ranks = sortedList.findIndex((data) => data.summoner.summoner_basic_info_dict.summoner_id === multiItem.summoner.summoner_basic_info_dict.summoner_id) + 1;
            const isDuo = reduceMap.filter((reduce) => reduce.summoner_id.some((some) => some === multiItem.summoner.summoner_basic_info_dict.summoner_id));
            const duo = isDuo.slice(0, 2)
            return (
                <MultiItem
                    isEven={(index + 1) % 2 === 0}
                    isLoading={isLoading}
                    setTypeButton={onChangeTypeButtonPressed}
                    typeButton={typeButtonPressed}
                    renderType={renderType}
                    ranks={ranks}
                    key={index + "multiItem"}
                    multiItem={multiItem}
                    isDuo={duo}
                    openId={openId}
                    handleLayer={handleLayer}
                />
            )
        })
    }, [multiList, typeButtonPressed, renderType,  openId, isLoading]);

;

    // if(multiList.length === 0) return   <SummonerNotFound userName={'???'}/>;

    return (
        <Wrapper>
            <MultiListContainer>
                <div className="t_head">
                    <div className="row">
                        <div className="col flex_column1 header1">{t('multi.head1')}</div>
                        <div className="col flex_column2 header2">{t('multi.head2')}</div>
                        <div className="col flex_column3 header3">{t('multi.head3')}
                            <ExtraSpan>{t('multi.head3Extra')}</ExtraSpan>
                            <MultiListType
                                renderType={renderType}
                                onClickButton={onClickTypeButton}
                            />
                        </div>
                        <div className="col flex_column4 header4">{t('multi.head4')}</div>
                    </div>
                </div>
                <div className="t_body">
                    {renderMap()}
                </div>
            </MultiListContainer>
        </Wrapper>
    );
};

export default MultiList;
